// The English strings the frame draws before any screen has loaded: the shell (bars, menus, search, errors, route titles), the session
// notices, sign-in states and the desk header. Everything else in ./en.ts arrives right after the first paint, and every screen waits for
// it before it draws (app/locales-ready.ts), so no screen ever shows a key. ECONIC bundle budget SH-22 (initial JS ≤ 300 KB gzip). WP-SHELL.
// The areas are the same objects ./econic/index.en.ts merges, so the values cannot drift; the full tree replaces this one when it lands.
import { deepMerge } from "./econic/deepMerge";
import authEn from "./econic/auth.en";
import desksEn from "./econic/desks.en";
import sessionEn from "./econic/session.en";
import shellEn from "./econic/shell.en";

const bootEn = deepMerge(["auth", authEn], ["session", sessionEn], ["shell", shellEn], ["desks", desksEn]);

export default bootEn;
